import styled, { css } from 'styled-components';
import { rem } from 'polished';
import { BUTTON_GROUP_LABEL_MARGIN } from '../constants/formConstants';
var ButtonGroup = styled.div.withConfig({
  displayName: "ButtonGroup",
  componentId: "cjy4u1-0"
})(["display:flex;flex-wrap:wrap;", " ", ""], function (_ref) {
  var buttonType = _ref.buttonType;
  return buttonType === 'pointer' && css(["flex-wrap:nowrap;justify-content:center;"]);
}, function (_ref2) {
  var buttonType = _ref2.buttonType;
  return (buttonType === 'pills' || buttonType === 'bubble') && css(["margin:0 -", ";"], rem(BUTTON_GROUP_LABEL_MARGIN));
});
export default ButtonGroup;